import { useNavigate, useOutletContext } from 'react-router-dom'

import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import EditGroupModal from 'modules/approvals/components/ApprovalsConfigurationBlock/_ApprovalGroupDescription/EditGroupModal'

const EditGroupPage = () => {
  const navigate = useNavigate()

  const { group } = useOutletContext<{ group: ApprovalsGroupFragment }>()

  return <EditGroupModal onClose={() => navigate(-1)} group={group} />
}

export default EditGroupPage
